export enum FeatureFlags {
  AuthDapp = 'dapps-auth-dapp',
  LAUNCHER_LINKS = 'dapps-launcher-links',
}
